import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { GLViewRow } from "../glViewTypes";
import { getGLTableMeta } from "./glCellHelpers";
import { JournalLineReferenceCell } from "./JournalLineCells";

export const GLReferenceCell = React.memo(function GLReferenceCell({
    row,
    table,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const { rowKind, transaction } = row.original;

    if (rowKind !== "transaction" || !transaction) {
        return <ViewTableCell />;
    }

    const onReferenceClick = getGLTableMeta(table)?.callbacks?.onReferenceClick;

    return (
        <JournalLineReferenceCell
            referenceNumber={transaction.referenceNumber}
            onClick={
                onReferenceClick
                    ? () => onReferenceClick(transaction)
                    : undefined
            }
        />
    );
});
